import React from "react";
import { ISearchValue, SearchTypeEnum } from "@/components/YhPageHeader/Types";
import { YhPageHeader } from "@/components/YhPageHeader";
import { DictCodeEnmu } from "@/types/AppDictEnums";
import { useDictModel } from "@/views/base/dict/dictModel";
import { useWrbModel } from "../wrbModel";

export function PageHeader() {
    const { getSelectedDictOne } = useDictModel(() => []);
    const {
        searchParam,
        updateSearchParam,
        resetSearchParam,
        loadData
    } = useWrbModel();

    const searchFields = [
        {
            type: SearchTypeEnum.Input,
            placeholder: "外贸合同号",
            fieldName: "code",
        },
        // {
        //     type: SearchTypeEnum.Input,
        //     placeholder: "报关单号",
        //     fieldName: "code",
        // },
        {
            type: SearchTypeEnum.Input,
            placeholder: "信用证号",
            fieldName: "creditCode",
        },
        {
            type: SearchTypeEnum.Select,
            placeholder: "币种",
            fieldName: "currencyCode",
            options:getSelectedDictOne(DictCodeEnmu.CURRENCY)
        },
        {
            type: SearchTypeEnum.Select,
            placeholder: "预警状态",
            fieldName: "warningType",
            options:getSelectedDictOne(DictCodeEnmu.WARNING)
        },
        {
            type: SearchTypeEnum.Datepicker,
            placeholder: "出运日期",
            fieldName: "shippingTime",
        },
        {
            type: SearchTypeEnum.RangePicker,
            fieldName: "",
            rangePickerFieldName: ["startTime", "endTime"],
            placeholder: ["收款起始日期", "收款结束日期"],
            // showTime: true,
            format: "YYYY-MM-DD",
            span: 16,
            xxl: 8,
        },
        // {
        //     type: SearchTypeEnum.Datepicker,
        //     placeholder: "收款日期",
        //     fieldName: "estimatedTime", 
        // },
    ]

    return (
        <YhPageHeader
            title="应收账款预警列表"
            size="small"
            justify="end"
            searchValues={searchParam as ISearchValue}
            searchFields={searchFields}
            onChange={updateSearchParam}
            triggerSearch
            handleSearch={(val = {}) => loadData({ pageNum: 1 }, { ...searchParam, ...val })}
            handleReset={resetSearchParam}
        />
    );
}